import { css } from '@emotion/react'
import { Tooltip } from '@mui/material'
import { DarkButton } from '@components'

export const buttonMargin = css`
  margin-left: 12px;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`

interface Props {
  buttonText: string
  isLoading: boolean
  contained?: boolean
  disabled?: boolean
  tooltipTitle?: string
  handleClick: () => void
}

export const ApprovalActionButton = ({
  buttonText,
  isLoading,
  contained = true,
  disabled = false,
  tooltipTitle = '',
  handleClick,
}: Props) => {
  if (disabled) {
    return (
      <Tooltip title={tooltipTitle} disableHoverListener={isLoading} data-testid="tooltip-wrapper">
        <span>
          <DarkButton disabled contained={contained} css={buttonMargin} data-testid="dark-button">
            {buttonText}
          </DarkButton>
        </span>
      </Tooltip>
    )
  }

  return (
    <DarkButton
      contained={contained}
      css={buttonMargin}
      onClick={handleClick}
      data-testid="dark-button"
    >
      {buttonText}
    </DarkButton>
  )
}
